import { Badge } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { AddMore } from "../../../../../../shared/svg/add-more";
import { CrossIcon } from "../../../../../../shared/svg/cross-icon";
import AddValueModal from "./addValueModal";

interface CsvFieldSectionProps {
  title: string;
  fieldKey: string;
  values: string[];
  onValuesChange: (values: string[]) => void;
  disabled?: boolean;
}

const CsvFieldSection = ({
  title,
  fieldKey,
  values,
  onValuesChange,
  disabled = false,
}: CsvFieldSectionProps) => {
  const normalizedValues = Array.isArray(values) ? values : [];
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddMoreClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalSave = (newValues: string[]) => {
    onValuesChange(newValues);
  };

  const handleRemoveValue = (valueToRemove: string) => {
    onValuesChange(normalizedValues.filter((value) => value !== valueToRemove));
  };

  return (
    <>
      <div className="rounded-lg border border-primaryGray-14 p-4">
        <div className="mb-3 flex items-center justify-between">
          <div className="text-sm font-semibold text-primaryGray-1">
            {title}
          </div>
          <button
            type="button"
            onClick={handleAddMoreClick}
            disabled={disabled}
            className="flex items-center gap-1 rounded border border-gray-800 bg-gray-800 px-3 py-1.5 text-tiny font-semibold text-white transition-colors hover:border-gray-700 hover:bg-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <div className="[&_svg_path]:fill-white">
              <AddMore />
            </div>
            Add More
          </button>
        </div>

        {/* Badges Display */}
        <div className="flex flex-wrap gap-2">
          {normalizedValues.length > 0 ? (
            normalizedValues.map((value, index) => (
              <div
                key={index}
                className="cursor-pointer transition-opacity duration-150 hover:opacity-85"
                onClick={() => !disabled && handleRemoveValue(value)}
              >
                <Badge
                  text={value}
                  backgroundColor="transparent"
                  textColor="#374151"
                  borderColor="#D1D5DB"
                  borderWidth="1px"
                  size="medium"
                  rightIcon={
                    !disabled ? (
                      <CrossIcon
                        width="12"
                        height="12"
                        fillColor="#EF4444"
                        strokeWidth="2.5"
                      />
                    ) : undefined
                  }
                />
              </div>
            ))
          ) : (
            <div className="text-sm text-primaryGray-6">
              No {title.toLowerCase()} added yet
            </div>
          )}
        </div>
      </div>

      <AddValueModal
        isOpen={isModalOpen}
        fieldKey={fieldKey}
        fieldTitle={title}
        existingValues={normalizedValues}
        onClose={handleModalClose}
        onSave={handleModalSave}
      />
    </>
  );
};

export default CsvFieldSection;
